
class modalBatchRed {
    constructor($scope, $uibModalInstance, items1) {
        $scope.modaldata = {
            invoiceIds: [],
            type: -1,
        }
        $scope = $.extend($scope, items1)
        $scope.invoiceList = items1
        $scope.invoiceType = $scope.invoiceList.length && $scope.invoiceList[0].invType
        $scope.totalMoney = 0
        $scope.totalTax = 0
        $scope.invoiceList.forEach((element) => {
            $scope.totalMoney += element.totalAmt
            $scope.totalTax += element.totalTaxamt
        })

        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function ok(type) {
            $scope.modaldata.invoiceIds = $scope.invoiceList.map((v) => v.invoiceId)
            $scope.modaldata.type = type
            $scope.modaldata.saleCreditCode = $scope.invoiceList[0].saleCreditCode
            $scope.modaldata.diskCode = $scope.invoiceList[0].diskCode
            $scope.modaldata.invType = $scope.invoiceList[0].invType
            $uibModalInstance.close($scope.modaldata)
        }
    }
}

modalBatchRed.$inject = ['$scope', '$uibModalInstance', 'items1']
export default modalBatchRed



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/modalBatchRed.js